const _ = require('lodash');

function SddDialogService(ContentOverlayService, LocalStorageService, BreakpointsService) {
    this.isOpen = false;
    this.ContentOverlayService = ContentOverlayService;
    this.BreakpointsService = BreakpointsService;
    this.localStorageService = LocalStorageService;
    this.fullfillmentOptions = { disableFullfillmentOptions: true };
    this.deliverySearch = {};
    this.onPanelClosed = null;
}

SddDialogService.prototype.open = function () {
    this.isOpen = true;
};

SddDialogService.prototype.close = function () {
    this.ContentOverlayService.close();
    this.showStoreList = false;
    this.isOpen = false;

    if (this.onPanelClosed && typeof this.onPanelClosed === 'function') {
        this.onPanelClosed();
    }
};

SddDialogService.prototype.toggle = function () {
    if (this.isOpen) {
        this.close();
    } else {
        this.open();
    }
};

module.exports = SddDialogService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/sdd-dialog/sdd-dialog-service.js
 **/